function u(t = {}, e = "") {
  return Object.keys(t).reduce((i, n) => {
    let $ = "";
    const o = e ? `${e}[${n}]` : n;
    return t[n] !== null && t[n] !== void 0 && (Array.isArray(t[n]) ? $ = t[n].reduce((r, f) => r === "" ? `${o}=${f}` : `${r}&${o}=${f}`, "") : typeof t[n] == "object" ? $ = u(t[n], o) : $ = `${o}=${t[n]}`, $) ? i === "" ? `${$}` : `${i}&${$}` : i;
  }, "");
}
function s(t, e = {}) {
  const i = u(e);
  return `${t}${i ? "?" : ""}${i}`;
}
function c(t) {
  if (!t)
    return "";
  let e = t;
  return e = e.replace(/^\/+/g, "/"), e = e.replace(/([^:]\/)\/+/g, "$1"), e;
}
const g = (t, e) => t.trim() ? /^[A-z0-9]*:\/\//gi.test(t) ? t.replace(/^[A-z0-9]*:\/\//gi, `${e}://`) : `${e}://${t.replace(/^\/+/, "")}` : t;
function l(t, e = "https") {
  if (!t)
    return "";
  const i = c(t);
  return g(i, e);
}
export {
  s as getApiLink,
  u as getQueryString,
  g as getWithProtocol,
  c as sanitize,
  l as sanitizeWithProtocol
};
